import { AdjustmentType, FinancialType } from "./Enums";
import { IncomeStatement } from "./index";

//#region "Response"
export class Adjustment {
    ID: string;
    ADJUSTMENT_TYPE: AdjustmentType;
    NAME: string;
    ADJUSTMENT_YEAR_LIST: Array<AdjustmentYear>;

    ORDER: string;
    
    static parse(json: any): Adjustment {
        if (json) {
            const a = new Adjustment();

            a.ID = json.ID;
            a.ADJUSTMENT_TYPE = AdjustmentType[<string>json.ADJUSTMENT_TYPE];
            a.NAME = json.NAME;
            if (json.ADJUSTMENT_YEAR_LIST)
                a.ADJUSTMENT_YEAR_LIST = AdjustmentYear.parseArray(json.ADJUSTMENT_YEAR_LIST);

            a.ORDER = json.ORDER;

            return a;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Adjustment> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Adjustment.parse(j));

        return arr;
    }

}

export class AdjustmentYear {
    ID: string;
    INCOME_STATEMENT: IncomeStatement;
    VALUE: number;

    static parse(json: any): AdjustmentYear {
        if (json) {
            const ay = new AdjustmentYear();

            ay.ID = json.ID;
            ay.INCOME_STATEMENT = json.INCOME_STATEMENT;
            ay.VALUE = json.VALUE;

            return ay;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<AdjustmentYear> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(AdjustmentYear.parse(j));

        return arr;
    }

}

//#endregion

//#region "Request"
export class AdjustmentModifyRequest {
    ID: string;
    ADJUSTMENT_TYPE: AdjustmentType;
    NAME: string
    ADJUSTMENT_YEAR_LIST: Array<AdjustmentYearModifyRequest>;

    static parse(json: any): AdjustmentModifyRequest {
        if (json) {
            const a = new AdjustmentModifyRequest();

            a.ID = json.ID;
            a.ADJUSTMENT_TYPE = AdjustmentType[<string>json.ADJUSTMENT_TYPE];
            a.NAME = json.NAME;
            if (json.ADJUSTMENT_YEAR_LIST)
                a.ADJUSTMENT_YEAR_LIST = AdjustmentYearModifyRequest.parseArray(json.ADJUSTMENT_YEAR_LIST);

            return a;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<AdjustmentModifyRequest> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(AdjustmentModifyRequest.parse(j));

        return arr;
    }

}

export class AdjustmentYearModifyRequest {
    INCOME_STATEMENT_ID: string;
    VALUE: number;

    // helper
    Year: number;
    financialType: FinancialType;

    static parse(json: any): AdjustmentYearModifyRequest {
        if (json) {
            const ay = new AdjustmentYearModifyRequest();

            ay.INCOME_STATEMENT_ID = json.INCOME_STATEMENT_ID;
            ay.VALUE = json.VALUE;

            return ay;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<AdjustmentYearModifyRequest> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(AdjustmentYearModifyRequest.parse(j));

        return arr;
    }

}
//#endregion